module.exports = __webpack_public_path__ + "static/media/udemy.a9d8fd59.png";